export const EMAIL_PLACEHOLDER = 'customer@example.com'

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
